// @flow
import {all,call,fork,put,takeEvery} from 'redux-saga/effects';
import {fetchJSON} from '../../helpers/api';
import {BASE_URL} from './../constants';
import {
    getRepoCyclestepsFailed,getRepoCyclestepsSuccess
} from './actions';
import {
    GET_REPOCYCLESTEPS
} from './constants';

function* getRepoCyclestepsInternal({ payload: { callbacks } }) {
    const {
        callbackOnBegin,
        callbackOnFailure,
        callbackOnFinish,
        callbackOnSuccess
    } = callbacks;
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        if (callbackOnBegin) {
            yield call(callbackOnBegin);
        }
        const response = yield call(fetchJSON, BASE_URL + 'api/localize/repo-cycleSteps', options);
        yield put(getRepoCyclestepsSuccess(response));
        if (callbackOnSuccess) {
            yield call(callbackOnSuccess, response);
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500:
                message = 'Internal Server Error';
                break;
            case 401:
                message = 'Invalid credentials';
                break;
            default:
                message = error;
        }
        yield put(getRepoCyclestepsFailed(message));
        if (callbackOnFailure) {
            yield call(callbackOnFailure, error);
        }
    } finally {
        if (callbackOnFinish) {
            yield call(callbackOnFinish);
        }
    }
}

export function* watchGetRepoCyclesteps() {
    yield takeEvery(GET_REPOCYCLESTEPS, getRepoCyclestepsInternal);
}

function* repocyclestepsSaga() {
    yield all([fork(watchGetRepoCyclesteps)]);
}

export default repocyclestepsSaga;
